export default __webpack_public_path__ + "static/media/ecamm_sponsor.fb9d7fbb.png";